import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

/**
 * Takes care of moving the whole selection area to the left or to the right
 * @param selection -
 * @param delta -
 */
export const moveSelectionArea = (
  selection: [RelativeAbsolutePosition, RelativeAbsolutePosition],
  delta: number,
): [RelativeAbsolutePosition, RelativeAbsolutePosition] => {
  const [startSelection, endSelection] = selection;

  const start: RelativeAbsolutePosition = {
    relative: {
      x: startSelection.relative.x + delta,
      y: startSelection.relative.y,
    },
    absolute: {
      x: startSelection.absolute.x + delta,
      y: startSelection.absolute.y,
    },
  };

  const end: RelativeAbsolutePosition = {
    relative: {
      x: endSelection.relative.x + delta,
      y: endSelection.relative.y,
    },
    absolute: {
      x: endSelection.absolute.x + delta,
      y: endSelection.absolute.y,
    },
  };

  return [start, end];
};
